import { JSX } from 'preact'
import classnames from 'classnames'
import { BlockType, TBlockProps } from '@gsc/types'
import { useComponentStyle } from '../Style'
import { Radio } from './Radio'

export function RadioGroup({ name, required, options = [], ...props }: TBlockProps<BlockType.RadioGroup>): JSX.Element {
  const { classes } = useComponentStyle('input-check', props)
  return (
    <div className={classnames(classes)}>
      {options.map(opt => (
        <Radio {...opt} name={name} required={required} />
      ))}
    </div>
  )
}
